export interface IUpsellData {
  dismissedCount: number;
  lastDismissedDate: string;
  shownCount: number;
  lastShownDate: string;
  isCompleted?: boolean;
}

export interface ISpamControlData {
  date: string;
  shownUpsellIds: string[];
}

export enum GROUP_TYPE {
  // new code
  estimatedSavingsUM30to399 = 'estimated_savings_um_30_399',
  estimatedSavings1to9 = 'estimated_savings_1_9',
  averageSavingsUM10to399 = 'average_savings_um_10_399',
  averageSavings1to9 = 'average_savings_1_9',
  estimatedSavingsUM10to29 = 'estimated_savings_um_10_29',
  estimatedSavingsUM30to49 = 'estimated_savings_um_30_49',
  default = 'default',
}

export type GROUP_TYPES =
  GROUP_TYPE.estimatedSavingsUM30to399 |
  GROUP_TYPE.estimatedSavings1to9 |
  GROUP_TYPE.averageSavingsUM10to399 |
  GROUP_TYPE.averageSavings1to9 |
  GROUP_TYPE.estimatedSavingsUM10to29 |
  GROUP_TYPE.estimatedSavingsUM30to49 |
  GROUP_TYPE.default | null;

export interface IGroupData {
  group: GROUP_TYPES,
  estimatedSavings?: IEstimatedSavings,
  fleetBundle?: IFleetBundle,
}

export interface IUpsellBannerGroupDetail {
  header: (potentialSavings: string) => string;
  body: string;
  primaryBtnText: string;
  secondaryBtnText: string;
  upsellId: string;
}

export interface IUpsellConfigData {
  estimated_savings_um_30_399: IUpsellBannerGroupDetail;
  estimated_savings_1_9: IUpsellBannerGroupDetail;
  average_savings_um_10_399: IUpsellBannerGroupDetail;
  average_savings_1_9: IUpsellBannerGroupDetail;
  estimated_savings_um_10_29: IUpsellBannerGroupDetail;
  estimated_savings_um_30_49: IUpsellBannerGroupDetail;
}

export interface IServerEarlyPromo {
   spend_required: number, promo_value: number, spend_multiplier?: number, promo_multiplier?: number ;
}

export interface IEstimatedSavingsServerResponse {
  pre_approved?: boolean;
  savings_estimate?: boolean;
  ifta_eligible: boolean;
  fleet_size?: number;
  annualized_fraud_savings: number;
  annualized_operational_savings: number;
  annualized_fuel_savings: number;
  annualized_promotional_savings: number;
  annualized_total_savings: number;
  cashback_percentage?: string;
  control_group_metadata: GROUP_TYPE;
  annualized_total_spend?: number;
  annualized_total_fuel_spend?: number;
  customer_type?: string;

  annualized_hidden_fee_savings: number;
  boosted_rebates: IBoostedRebatesServerResponse[];
  savings_pdf_link: string;
  fleet_bundle_savings: string;
  early_spend_promo?: IServerEarlyPromo;

  fleet_operation_type?: string;
}

export interface IEarlyPromo {
  spendRequired: number, promoValue: number, spendMultiplier?: number, promoMultiplier?: number
}

export interface IEstimatedSavings {
  preApproved: boolean; // Todo: remove it
  savingsEstimate: boolean;
  iftaEligible: boolean;
  annualizedFraudSavings: number;
  annualizedOperationalSavings: number;
  annualizedHiddenFeeSavings: number;
  annualizedFuelSavings: number;
  annualizedTotalSavings: number;
  annualizedPromotionalSavings: number;
  boostedRebates: IBoostedRebates[]; // Todo: remove it
  savingsPdfLink: string;
  fleetBundleSavings?: string;
  controlGroupMetadata?: GROUP_TYPE;
  earlySpendPromo?: IEarlyPromo;

  cashbackPercentage?: string;
  fleetSize?: number;
  fleetOperationType?: string;
  annualizedTotalSpend?: number;
  annualizedTotalFuelSpend?: number;
  customerType?: string;
}

export interface IFleetBundleServerResponse {
  estimated_rewards: number;
  contract_value: number;
  contract_type: 'ACV' | 'TCV';
  fleet_bundle_percentage: number;
}

export interface IFleetBundle {
  estimatedRewards: number;
  contractValue: number;
  contractType: 'ACV' | 'TCV';
  fleetBundlePercentage: number;
}

export interface IBoostedRebates {
  partner: string,
  rebateValue: number,
  logoLink: string,
}

export interface IBoostedRebatesServerResponse {
  partner: string,
  rebate_value: string,
  logo_link: string,
}